import React from "react";

export default function EventToggle({ value, onChange }) {
  return (
    <div className="relative w-64 h-10 flex border border-primary-500 rounded overflow-hidden cursor-pointer select-none">
      {/* Highlight-Hintergrund */}
      <div
        className="absolute top-0 h-full w-1/2 bg-primary-500 transition-all duration-300"
        style={{ left: value === "Kinder" ? "0%" : "50%" }}
      />
      {/* Links */}
      <button
        className={`flex-1 uppercase tracking-widest z-10 transition-colors duration-300 ${
          value === "Kinder"
            ? "text-black font-semibold"
            : "text-white hover:text-gray-300"
        }`}
        onClick={() => onChange("Kinder")}
      >
        Kinder
      </button>
      {/* Rechts */}
      <button
        className={`flex-1 uppercase tracking-widest z-10 transition-colors duration-300 ${
          value === "Erwachsene"
            ? "text-black font-semibold"
            : "text-white hover:text-gray-300"
        }`}
        onClick={() => onChange("Erwachsene")}
      >
        Erwachsene
      </button>
    </div>
  );
}
